import React from 'react';
import { RiAlertLine } from 'react-icons/ri';

import Modal from '~/components/Modal';
import colors from '~/styles/colors';

import {
  ModalContainer,
  ModalContentContainer,
  ModalSubmitButton,
  ModalCancelButton,
} from './styles';

interface ConfirmationAlertProps {
  onOk: () => void;
  onCancel: () => void;
  modalState: (opened: boolean) => void;
  open: boolean;
  customHeaderMessage?: string;
  customParagraphMessage?: string;
}

const ConfirmationAlert: React.FC<ConfirmationAlertProps> = ({
  onOk,
  onCancel,
  modalState,
  open,
  customHeaderMessage,
  customParagraphMessage,
}) => {
  return (
    <ModalContainer>
      <Modal
        closeButtonAction={onCancel}
        disableScrollBar
        open={open}
        modalState={modalState}
      >
        <ModalContentContainer>
          <RiAlertLine size={56} color={colors.primary} />
          <h2>{customHeaderMessage ?? 'As alterações serão descartadas.'}</h2>
          <p>{customParagraphMessage ?? 'Deseja prosseguir?'}</p>
          <div>
            <ModalCancelButton type="button" onClick={onCancel}>
              Não
            </ModalCancelButton>
            <ModalSubmitButton type="button" onClick={onOk}>
              Sim
            </ModalSubmitButton>
          </div>
        </ModalContentContainer>
      </Modal>
    </ModalContainer>
  );
};

export default ConfirmationAlert;
